import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class UserTableSettingsService {
    constructor(private apiHttp: ApiHttp) {
    }

    public GetUserTableSettings(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/UserTableSettings/GetUserTableSettings', data, messageService);
    }

    public SaveUserTableSettings(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/UserTableSettings/SaveUserTableSettings', data, messageService);
    }
}
